import { css } from '@emotion/core';
import { StyledColumnWrapper } from './styles';
export default (function (theme) {
  return /*#__PURE__*/css(StyledColumnWrapper, "{display:grid;grid-template-columns:auto auto;align-items:center;justify-items:space-between;.image-box{min-width:64px;}}");
});